import i18n from 'i18next';

import { sharedTypes } from '@/shared/Constants';

const initialState = {
	loading: false,
	userData: {
		bridge_game: {},
	},
	triggerMessagePresent: false,
	translationsInstance: i18n.t,
	backgroundColor: null,
	backgroundPattern: null,
	openMobileFooterMenu: false,
	openGeneralFeedbackForm: false,
};

const prefillPasswordSettings = (userData) => {
	const { sidk_user, has_default_goal, settings } = userData || {};

	if (!settings) {
		return settings;
	}

	if (!sidk_user && !has_default_goal) {
		return settings;
	}

	return {
		...settings,
		password: {
			...settings?.password,
			...(sidk_user
				? {
						view_activity_page: false,
						view_progress_page: false,
				  }
				: {}),
			...(has_default_goal
				? {
						update_learning_goals: false,
				  }
				: {}),
		},
	};
};

export default function sharedReducer(state = initialState, action) {
	const { type, payload } = action;

	const {
		backgroundColor,
		backgroundPattern,
		data,
		translationsInstance,
		userData,
		openMobileFooterMenu,
		openGeneralFeedbackForm,
		settings,
	} = payload || {};

	switch (type) {
		case sharedTypes.GET_USER_DATA_REQUEST:
			return {
				...state,
				loading: true,
			};

		case sharedTypes.GET_USER_DATA_SUCCESS:
			const reward = userData?.reward || {};
			return {
				...state,
				userData: {
					// TODO: remove bridge_game fallback — will come from the API
					bridge_game: initialState.userData.bridge_game,
					...userData,
					settings: prefillPasswordSettings(userData),
				},
				backgroundColor: reward?.visible ? reward?.background_color : null,
				backgroundPattern: reward?.visible ? reward?.background_pattern : null,
				loading: false,
			};

		case sharedTypes.GET_USER_DATA_ERROR:
			return {
				...state,
				loading: false,
			};

		case sharedTypes.CLEAR_USER_DATA:
			return {
				...state,
				userData: initialState.userData,
			};

		case sharedTypes.SEND_EVENT_SUCCESS:
			return {
				...state,
				...data,
			};

		case sharedTypes.SEND_EVENT_ERROR:
			return {
				...state,
			};

		case sharedTypes.SET_TRANSLATIONS_INSTANCE:
			return {
				...state,
				translationsInstance,
			};

		case sharedTypes.SET_BACKGROUND_COLOR:
			return {
				...state,
				backgroundColor,
			};

		case sharedTypes.SET_BACKGROUND_PATTERN:
			return {
				...state,
				backgroundPattern,
			};

		case sharedTypes.TOGGLE_MOBILE_FOOTER_MENU:
			return {
				...state,
				openMobileFooterMenu,
			};

		case sharedTypes.TOGGLE_GENERAL_FEEDBACK_FORM:
			return {
				...state,
				openGeneralFeedbackForm,
			};

		case sharedTypes.UPDATE_USER_DATA_SETTINGS:
			return {
				...state,
				userData: {
					...state.userData,
					settings,
				},
			};

		default:
			return state;
	}
}
